import { makeAutoObservable } from 'mobx';

export class NavbarStore {
  isNavigationRestricted: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setisNavigationRestricted = (val: boolean) => {
    this.isNavigationRestricted = val;
  };
}
